import type { Locale } from "@/utils/translations"

export const localizeDate = (locale: Locale, date: string) => {
  const newDate = new Date(date)
  const year = newDate.getFullYear()
  const month = String(newDate.getMonth() + 1).padStart(2, "0")
  const day = String(newDate.getDate()).padStart(2, "0")
  return {
    locale: newDate.toLocaleDateString(locale, {
      year: "numeric",
      month: "long",
      day: "numeric",
    }),
    meta: `${year}-${month}-${day}`,
  }
}
